import { jsxs as l, jsx as n } from "react/jsx-runtime";
import t from "../../../node_modules/prop-types/index.es.js";
import { useRef as p, useState as g, useEffect as I } from "react";
import * as N from "./style.es.js";
import { StepBar as T, StepBarSteps as q, StepBarStep as O, StepBarStepBox as j, StepBarStepBody as z, StepBarLine as k, StepBarLineProgress as v } from "./style.es.js";
import { Typography as m } from "../../Typography/Typography.es.js";
import { Icon as w } from "../Icon/Icon.es.js";
function a({
  activeStepIndex: i = 0,
  direction: c,
  labelPosition: s,
  steps: r
}) {
  const f = p(null), d = p(null), [S, u] = g(0), [B, y] = g(0);
  function R(e) {
    return e.iconName ? /* @__PURE__ */ n(w, { name: e.iconName }) : e.icon ? e.icon : e.stepIndex;
  }
  I(() => {
    const e = f.current, o = d.current;
    r && r.length > 0 && (e && u(e.offsetWidth), r.length > 1 && o && o !== e && y(o.offsetWidth));
  }, [r, i, c, s]);
  const b = r.length > 1 ? 100 / (r.length - 1) * i : 0, E = r.length > 1 ? 100 / (r.length - 1) * (0.4 * (i || 1) * (i ? 1.25 : 1)) : 0;
  return /* @__PURE__ */ l(T, { labelPosition: s, direction: c, stepsLength: r.length, children: [
    /* @__PURE__ */ n(q, { children: r == null ? void 0 : r.map((e, o) => {
      const W = e.stepIndex === i, x = e.stepIndex < i, L = o === 0, P = o === r.length - 1;
      return /* @__PURE__ */ l(
        O,
        {
          ref: (h) => {
            L && (f.current = h), P && (d.current = h);
          },
          isActive: W,
          isCompleted: x,
          children: [
            /* @__PURE__ */ n(j, { children: R(e) }),
            /* @__PURE__ */ l(z, { children: [
              /* @__PURE__ */ n(m, { variant: "body2Bold", style: {
                marginTop: 5
              }, children: e.label }),
              e.description && /* @__PURE__ */ n(m, { variant: "body2", color: "fg", emphasis: "weak", children: e.description })
            ] })
          ]
        },
        e.stepIndex
      );
    }) }),
    /* @__PURE__ */ n(k, { leftEdgeStepWidth: S, rightEdgeStepWidth: B, children: /* @__PURE__ */ n(v, { progress: b + E }) })
  ] });
}
a.S = N;
a.displayName = "StepBar";
a.propTypes = {
  activeStepIndex: t.number,
  // Changed from isRequired to match defaultProp
  direction: t.oneOf(["horizontal", "vertical"]),
  labelPosition: t.oneOf(["start", "end"]),
  steps: t.arrayOf(t.shape({
    description: t.string,
    icon: t.node,
    iconName: t.string,
    stepIndex: t.number.isRequired,
    label: t.string.isRequired
  })).isRequired
};
a.defaultProps = {
  activeStepIndex: 0,
  direction: "horizontal",
  // Example default
  labelPosition: "end"
  // Example default
};
export {
  a as StepBar
};
//# sourceMappingURL=StepBar.es.js.map
